import * as React from "react";

import { LoggerService } from "@/shared/services";

interface IFileTransferContext {
  // Parse the event data for files, and upload the files to the backend
  beginFileUpload: (
    event: React.DragEvent<HTMLElement> | React.ChangeEvent<HTMLInputElement>,
    orgId: string,
    datasetId: string,
    prefix?: string,
  ) => Promise<void>;
  isUploading: boolean;
  beginExportJob: (exportJobId: string, label: string) => void;
}

export const FileTransferContext = React.createContext<IFileTransferContext>({
  beginFileUpload() {
    LoggerService.log("TODO: WRAP IN VALID FILE TRANSFER PROVIDER");
    return Promise.resolve();
  },
  isUploading: false,
  beginExportJob() {
    LoggerService.log("TODO: WRAP IN VALID FILE TRANSFER PROVIDER");
  },
});

export const useFileTransfer = (): IFileTransferContext => {
  return React.useContext(FileTransferContext);
};
